import OfferDetailsModal from './OfferDetailsModal';

export default OfferDetailsModal;
